export interface IColorizeBy {
  name: string;
  id: string;
  disabled: boolean;
  orderIndex: number;
}

export const regionNames:{[key: string]: string} = {};
//USA
regionNames["ENC"] = "East North Central";
regionNames["ESC"] = "East South Central";
regionNames["MA"] = "Mid Atlantic";
regionNames["NE"] = "New England";
regionNames["SA"] = "South Atlantic";
regionNames["WM"] = "West Mountain";
regionNames["WNC"] = "West North Central";
regionNames["WP"] = "West Pacific";
regionNames["WSC"] = "West South Central";
//CAN
regionNames["ATL"] = "Atlantic Canada";
regionNames["BCL"] = "British Columbia";
regionNames["ONT"] = "Ontario";
regionNames["PRA"] = "Prairies";
regionNames["QBC"] = "Quebec";
regionNames["TER"] = "Territories";

export const colorizeBy: IColorizeBy[] = [
    {
        name: "Single Color",
        id: "Single Color",
        disabled: false,
        orderIndex: 1,
    },
    {
        name: "Quadrant",
        id: "Quadrant",
        disabled: false,
        orderIndex: 2,
    },
    {
        name: "Model",
        id: "Model",
        disabled: false,
        orderIndex: 3,
    },
    {
        name: "Locations",
        id: "Locations",
        disabled: true,
        orderIndex: 4,
    },
    {
        name: "BUDS",
        id: "BUDS",
        disabled: true,
        orderIndex: 5,
    },
    {
        name: "Region",
        id: "Region",
        disabled: true,
        orderIndex: 6,
    },
];
